export const ESITO = {
  proponibile: { label: "Proponibile", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  proponibile_con_mitigazioni: { label: "Proponibile con mitigazioni", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  non_proponibile: { label: "Non proponibile", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const STATO = {
  bozza: { label: "Bozza", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  valutata: { label: "Valutata", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  relazione: { label: "Relazione pronta", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

export const FORME_GIURIDICHE = [
  "S.r.l.", "S.r.l.s.", "S.p.A.", "S.n.c.", "S.a.s.", "Ditta individuale",
  "Cooperativa", "Cooperativa sociale", "Fondazione", "Associazione (APS/ODV/ETS)", "Consorzio", "Altro",
];

export const TIPI_GARANZIA = {
  anticipazione: "Anticipazione",
  contributo_pubblico: "Contributo pubblico",
  altra_cauzione: "Altra cauzione",
};

export const PARERE = {
  favorevole: "Favorevole",
  favorevole_con_riserve: "Favorevole con riserve",
  non_favorevole: "Non favorevole",
};

export function riskBand(score, alta, minima) {
  if (score == null) return null;
  if (score >= alta) return "low";
  if (score >= minima) return "medium";
  return "high";
}

export function euro(n) {
  if (n == null || n === "") return "—";
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n));
}
